import React from "react";
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";


class ErrorView extends React.Component {

    static propTypes = {
        errorMessage: PropTypes.string.isRequired,
    };

    _handleClearErrorButtonClicked = (event) => {
        EventPublisher.publish(UIInteractionEvents.CLEAR_ERROR_BUTTON_CLICKED, {});
    };

    render() {
        return (
            <div className="container">
                <div className="row justify-content-sm-center">
                    <div className="col-6">
                        <div className="card text-center">
                            <div className="card-header">
                                Oh No!!
                            </div>
                            <div className="card-body">
                               It looks like an unexpected error has occurred with our servers. The problem message is:
                                <div className="alert alert-danger" role="alert">
                                    {this.props.errorMessage}
                                </div>
                                We are very sorry.  Please attempt to reset everything and try again. If this error
                                continues, please reach out to us and we will fix it as soon as possible.
                            </div>
                            <div className="card-footer">
                                <button className="btn btn-primary" onClick={this._handleClearErrorButtonClicked}>
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


}

export default ErrorView;